import React, { useEffect, useRef, useState } from 'react';
import { Box } from '../../../components/UI-CHAKRA/Box';
import { Button } from '../../../components/UI-CHAKRA/Button';
import { Flex } from '../../../components/UI-CHAKRA/Flex';
import { Spinner } from '../../../components/UI-CHAKRA/Spinner';
import { Text } from '../../../components/UI-CHAKRA/Text';
import { ReactComponent as SuccessIcon } from '../../../assets/images/icons/success.svg';
import { ReactComponent as ErrorIcon } from '../../../assets/images/icons/error.svg';
import { FONT_ONEST, SNCR_COLORS } from './constants';
import { postGovBrSessionToOpener, saveGovBrSession } from './govBrLogin';
import { APP_VIEWPORT_HEIGHT } from '../../../helpers/embeddedViewport';

type CallbackStatus = 'processing' | 'done' | 'error';

const CLOSE_WINDOW_DELAY_MS = 3000;

export default function SncrCallback() {
  const hasHandledRef = useRef(false);
  const [status, setStatus] = useState<CallbackStatus>('processing');

  useEffect(() => {
    if (hasHandledRef.current) return;
    hasHandledRef.current = true;

    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get('session_id');
    const state = params.get('state');

    window.history.replaceState(null, '', window.location.pathname);

    if (!sessionId) {
      setStatus('error');
      setTimeout(() => window.close(), CLOSE_WINDOW_DELAY_MS);
      return;
    }

    saveGovBrSession(state, sessionId);
    postGovBrSessionToOpener(state, sessionId);
    setStatus('done');
    setTimeout(() => window.close(), CLOSE_WINDOW_DELAY_MS);
  }, []);

  return (
    <Flex minH={APP_VIEWPORT_HEIGHT} align="center" justify="center" bg={SNCR_COLORS.controlBg} fontFamily={FONT_ONEST}>
      <Box
        bg="white"
        borderRadius="12px"
        border={`1px solid ${SNCR_COLORS.cardBorder}`}
        padding="32px"
        width="100%"
        maxW="400px"
        textAlign="center"
      >
        {status === 'processing' && (
          <Flex direction="column" align="center" gap="16px">
            <Spinner boxSize="80px" thickness="5px" color={SNCR_COLORS.primary} emptyColor={SNCR_COLORS.border} />
            <Text textAlign="start" fontSize="16px" width="100%" fontWeight={700} color={SNCR_COLORS.textPrimary} fontFamily={FONT_ONEST}>
              Concluindo a autenticação via Gov.br...
            </Text>
          </Flex>
        )}

        {status === 'done' && (
          <Flex direction="column" align="center" gap="16px" width="100%">
            <SuccessIcon width={80} height={80} />
            <Text textAlign="start" fontSize="16px" width="100%" fontWeight={700} color={SNCR_COLORS.textPrimary} fontFamily={FONT_ONEST}>
              Autenticação concluída com sucesso!
            </Text>
            <Text textAlign="start" fontSize="14px" fontWeight={400} color={SNCR_COLORS.textSecondary} fontFamily={FONT_ONEST}>
              Sua credencial do Gov.br foi validada, você já pode fechar esta janela e retornar à Mevo.
            </Text>
            <Button
              bg={SNCR_COLORS.primaryButton}
              color="white"
              width="100%"
              fontSize="14px"
              fontFamily={FONT_ONEST}
              fontWeight={700}
              py="11px"
              rounded="40px"
              onClick={() => window.close()}
            >
              Fechar
            </Button>
          </Flex>
        )}

        {status === 'error' && (
          <Flex direction="column" align="center" gap="16px" width="100%">
            <ErrorIcon width={80} height={80} />
            <Text textAlign="start" fontSize="16px" fontWeight={700} color={SNCR_COLORS.textPrimary} fontFamily={FONT_ONEST}>
              Não foi possível concluir a autenticação
            </Text>
            <Text textAlign="start" fontSize="14px" color={SNCR_COLORS.textSecondary} fontFamily={FONT_ONEST}>
              Tente novamente pela plataforma. Se o erro persistir, faça login novamente no Gov.br.
            </Text>
            <Button
              bg={SNCR_COLORS.primaryButton}
              color="white"
              width="100%"
              fontSize="14px"
              fontFamily={FONT_ONEST}
              fontWeight={700}
              py="11px"
              rounded="40px"
              onClick={() => window.close()}
            >
              Voltar para a Mevo
            </Button>
          </Flex>
        )}
      </Box>
    </Flex>
  );
}
